import { render, staticRenderFns } from "./ViajesIndex.vue?vue&type=template&id=74c6eab3"
import script from "./ViajesIndex.vue?vue&type=script&lang=js"
export * from "./ViajesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports